import { writable } from "svelte/store";

export const tray = writable({
  route: "",
  ids: [],
});
